// let IS_PROD = true;
// const server = IS_PROD ?
//     "https://zoom-clone-backend-wbqe.onrender.com/":

//     "http://localhost:8000"


// export default server;

let IS_PROD = true;
const server = IS_PROD ?
    "https://apnacollegebackend.onrender.com" :

    "http://localhost:8000"


export default server;
